import { civilities } from "../../static/types/commonTypes/individualType"
import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import { ReducedIndividualPersonType } from "../../static/types/commonTypes/reducedIndividualPersonType"
import reducedIndividualPersonValidationSchema from "../../utils/validation/reducedIndividualPersonValidationSchema"
import { useDraftManager } from "../../hooks/useDraftManager"

type individualProps = {
    checked: boolean,
    reducedIndividualPerson: ReducedIndividualPersonType,
    draftFieldName?: string,
    changeReducedIndividualPerson: ( data: Partial<ReducedIndividualPersonType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function ReducedIndividualPerson ({
    checked,
    reducedIndividualPerson,
    draftFieldName = 'reducedIndividualPerson',
    changeReducedIndividualPerson,
    onValidationChange
}: individualProps ) {

    const { errors, isValid } = useValidation( reducedIndividualPerson, reducedIndividualPersonValidationSchema )

    const { pushDraftContent } = useDraftManager()

    useEffect( () => {
        onValidationChange( isValid )
        pushDraftContent({[ draftFieldName ] : reducedIndividualPerson })
    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "civility" className = "col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-4">

                <select
                    className={`form-select ${(checked && errors.civility) ? 'is-invalid' : ''}`}
                    name="civility"
                    id="civility"
                    value={reducedIndividualPerson.civility || "Monsieur"}
                    onChange={event => changeReducedIndividualPerson({ civility: event.target.value as "Monsieur" | "Madame" })}
                >
                    {civilities.map(option => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
                    {  ( checked && errors.civility ) && <div className="invalid-feedback"> { errors.civility } </div> }

                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "lastName" className = "col-sm-2 col-form-label">Nom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.lastName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "nom"
                        id = "lastName"
                        value = { reducedIndividualPerson.lastName }
                        onChange = { event => changeReducedIndividualPerson({ lastName: event.target.value })}

                    />
                    {  ( checked && errors.lastName ) && <div className="invalid-feedback"> { errors.lastName } </div> }

                </div>

                <label htmlFor = "firstName" className = "col-sm-2 col-form-label">Prénom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.firstName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "firstName"
                        value = { reducedIndividualPerson.firstName }
                        onChange = { event => changeReducedIndividualPerson({ firstName: event.target.value })}
                    />
                    {  ( checked && errors.firstName ) && <div className="invalid-feedback"> { errors.firstName } </div> }

                </div>
            </div>
        </div>
    )
}